module.exports = __webpack_public_path__ + "static/img/nomsg.e04beb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nomsg.png
// module id = 198
// module chunks = 1